export default __webpack_public_path__ + "static/Scroll-Image---Mobile-Home-Demolition-f9d074bf74589b03ef9ed2e0524f940f.jpg";